// eslint-disable-next-line import/prefer-default-export

export const parametersActions = {
    setDate(value){
        console.log(value)
    },

    setInstallationMainCalendarRefresh: ({ commit }, data = {
        status: Boolean
    }) => {
        commit('SET_MAIN_CALENDAR_REFRESH', data.status)
    },

    setInstallationAuditDate: ({ commit }, data = {
        start_date: String, end_date: String
    }) => {
        commit('SET_DATES_START', data.start_date)
        commit('SET_DATES_END', data.end_date)
    },

    setInstallationExpertDate: ({ commit }, data = {
        start_date: String, end_date: String
    }) => {
        commit('SET_EXPERT_DATES_START', data.start_date)
        commit('SET_EXPERT_DATES_END', data.end_date)
    },

    setInstallationNiv2Date: ({ commit }, data = {
        start_date: String, end_date: String
    }) => {
        commit('SET_NIV2_DATES_START', data.start_date)
        commit('SET_NIV2_DATES_END', data.end_date)
    },

    setInstallationParcDate: ({ commit }, data = {
        start_date: String
    }) => {
        commit('SET_PARC_DATES_START', data.start_date)      
    },

    setInstallationExpertCalendarRefresh: ({ commit }, data = {
        status: Boolean
    }) => {
        commit('SET_EXPERT_CALENDAR_REFRESH', data.status)
    },

    setInstallationMaxDates: ({commit}, data = {
        start_date: String, end_date: String
    }) => {
        commit('SET_AUDIT_DATES_START', data.start_date)
        commit('SET_AUDIT_DATES_END', data.end_date)
    },

    setShowDateSelector({ commit }, data = {
        show: Boolean
    }) {
        commit('SET_SHOW_DATE_SELECTOR', data.show)
    },

    setGeoPdm({ commit }, data = {
        pdm_list: String
    }) {
        commit('SET_GEO_PDM', data.pdm_list.toString())
    },

    setGeoTimeStep({ commit }, data = {
        timestep: String
    }) {
        commit('SET_GEO_TIMESTEP', data.timestep)
    },
    
    // setExpertPdm({ commit }, data = {
    //     pdm: String
    // }) {
    //     commit('SET_EXPERT_PDM', data.pdm)
    // },
};
